import React, { useEffect, useState, useCallback } from "react";
import "./ProductLoanDocuments.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  FaSearch,
  FaFilter,
  FaTable,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { toast } from "react-toastify";

const ProductLoanDocuments = () => {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchLoans = useCallback(async (page = currentPage) => {
    if (!profile?.id) return;
    setLoading(true);
    try {
      const res = await axios.get("https://payyug.in/api/product-loan/report", {
        params: {
          superAdminId: profile.superAdminId || 14,
          employeeId: profile.id,
          page,
          limit: itemsPerPage === "all" ? 100000 : itemsPerPage,
        },
      });

      if (res.data.success) {
        setLoans(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Data load karne mein dikkat hui");
    } finally {
      setLoading(false);
    }
  }, [profile, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchLoans();
  }, [fetchLoans]);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(e.target.value === "all" ? "all" : parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

const filteredLoans = loans.filter((loan) => {
  const search = searchTerm.toLowerCase();
  
  // Checking all 3 fields
  const matchForm = loan.formNo?.toLowerCase().includes(search);
  const matchName = loan.customer?.fullName?.toLowerCase().includes(search);
  const matchId = String(loan.customer?.userId || "").toLowerCase().includes(search);

  // Agar koi bhi match ho jaye, toh dikhayein
  return matchForm || matchName || matchId;
});

  const navigateTo = (path, loan) => {
    navigate(path, {
      state: {
        loan,
        customerId: loan?.customer?.userId,
        superAdminId: loan.superAdminId,
      },
    });
  };

  return (
    <div className="product-loan-document-container">
      <h2 style={{textAlign:"center"}}>Product Loan Documents</h2>
      {/* Filter Section */}
      <section className="product-loan-document-filter-box">
  {/* <div className="product-loan-document-filter-title">
    <FaFilter className="product-loan-document-title-icon" />
    <h3>Search Loan Records</h3>
  </div> */}
  
  {/* Single Search Input */}
  <div className="product-loan-document-filter-input-fields" style={{ maxWidth: "400px" }}>
    <label>Search</label>
    <div className="product-loan-document-filter-input-with-icon">
      <FaSearch />
      <input
        type="text"
        placeholder="Search by Form No, Name, or ID..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  </div>
</section>

      {/* Table Section */}
      <section className="product-loan-document-wrapper">
        <div className="product-loan-document-box-header">
          <div className="product-loan-document-box-header-left">
            <FaTable className="product-loan-document-title-icon" />
            <h3>Product Loan Records</h3>
            <select
              className="lsr-app-select-limit"
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
            >
              <option value={10}>10 Rows</option>
              <option value={25}>25 Rows</option>
              <option value={50}>50 Rows</option>
              <option value="all">All Records</option>
            </select>
          </div>
        </div>

        <div className="product-loan-document-table-container">
          <table className="product-loan-document-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Customer Id</th>
                <th>Customer Name</th>
                <th>Form No.</th>
                <th>Loan Amount</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>Loading data...</td>
                </tr>
              ) : filteredLoans.length > 0 ? (
                filteredLoans.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * (itemsPerPage === "all" ? 0 : itemsPerPage) + index + 1}</td>
                    <td>{item?.customer?.userId || "N/A"}</td>
                    <td>{item?.customer?.fullName || "N/A"}</td>
                    <td>{item?.formNo || "N/A"}</td>
                    <td>₹{item.loanAmount?.toLocaleString()}</td>
                    <td>
                      <span className={`product-loan-document-table-badge product-loan-document-table-badge-${item.status?.toLowerCase()}`}>
                        {item.status}
                      </span>
                    </td>
                    <td>
                      {(item.status.toLowerCase() === "approved" || item.status.toLowerCase() === "disbursed") && (
                        <div style={{ display: "flex", gap: "5px" }}>
                          <button onClick={() => navigateTo(`/ProductLoan/ProductLoanSanction/${item.id}`, item)}>Sanction</button>
                          <button onClick={() => navigateTo(`/ProductLoan/ProductLoanPromise/${item.id}`, item)}>Promise</button>
                          <button onClick={() => navigateTo(`/ProductLoan/ProductLoanAgreement/${item.id}`, item)}>Agreement</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>No Data found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && itemsPerPage !== "all" && (
          <div className="product-loan-document-pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              <FaChevronLeft />
            </button>
            <span>Page <strong>{currentPage}</strong> of {totalPages}</span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              <FaChevronRight />
            </button>
          </div>
        )}
      </section>
    </div>
  );
};

export default ProductLoanDocuments;